import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import {
  AccountSelector,
  reducer as accountSelectorReducer,
  saga as accountSelectorSaga,
} from './accountSelector';
import {
  ContactSelector,
  reducer as contactSelectorReducer,
  saga as contactSelectorSaga,
} from './contactSelector';
import {
  OpDefSelector,
  reducer as opDefSelectorReducer,
  saga as opDefSelectorSaga,
} from './opDefSelector';
import {
  ProcessSelector,
  reducer as processSelectorReducer,
  saga as processSelectorSaga,
} from './processSelector';
import {
  SupplierFacilitySelector,
  reducer as supplierFacilitySelectorReducer,
  saga as supplierFacilitySelectorSaga,
} from './supplierFacilitySelector';

const reducer = combineReducers({
  accountSelector: accountSelectorReducer,
  contactSelector: contactSelectorReducer,
  opDefSelector: opDefSelectorReducer,
  processSelector: processSelectorReducer,
  supplierFacilitySelector: supplierFacilitySelectorReducer,
});

const saga = function* () {
  yield all([
    accountSelectorSaga(),
    contactSelectorSaga(),
    opDefSelectorSaga(),
    processSelectorSaga(),
    supplierFacilitySelectorSaga(),
  ]);
};

export {
  reducer,
  saga,
  SupplierFacilitySelector,
  ProcessSelector,
  AccountSelector,
  OpDefSelector,
  ContactSelector,
};
